import { BusinessContact, BusinessContactSchema } from '@40seas/entities/businesses';
import { EnumSchema, Executor, FromSchema, requireFields } from '@40seas/entities/common';
import { Invite, InviteSchema } from '@40seas/entities/invites';
import { Address, AddressSchema, TenantlessBaseEntity, WithTenantlessBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { LeadHubspotReference, LeadHubspotReferenceSchema } from './lead.hubspot.reference';
import { LeadStatus } from './lead.status';

export const LeadsSchema = WithTenantlessBaseEntitySchema(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
    z.object({
        address: requireFields(AddressSchema, ['country', 'city', 'zipCode', 'addressLine1']),
        contact: BusinessContactSchema,
        legalName: z.string().min(2).max(250),
        invite: z
            .string()
            .regex(/^[0-9a-f]{24}$/i)
            .or(InviteSchema)
            .optional(),
        website: z.string().optional(),
        status: EnumSchema(LeadStatus),
        logo: z.string().optional(),
        organization: z.string().optional(),
        hubspotReference: LeadHubspotReferenceSchema.optional(),
    }),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
).strict();

export class Lead extends FromSchema(LeadsSchema) implements TenantlessBaseEntity {
    id: string;
    status: LeadStatus;
    invite?: string | Invite;
    address: Address;
    website?: string;
    contact: BusinessContact;
    legalName: string;
    logo?: string;
    organization?: string;
    hubspotReference?: LeadHubspotReference;
    createdAt: Date;
    updatedAt: Date;
    createdBy: Executor;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
